import {Observable} from 'rxjs';
import {palipaliAPI} from '../provider/palipaliAPI';
import {ApiOperationResponseFunction} from '../base/apiConnectionInfrastructure';
import {RestQueryParams} from '../base/queryParams';
import {IPaymentClientSecretOutput} from '../../model/payment';
import {IApiSingleResponseBase} from '../../types';

export const getPaymentClientSecretAPI: ApiOperationResponseFunction<IPaymentClientSecretOutput> = (
    authToken: string,
    payload: {paymentAccountId: string}
): Observable<IApiSingleResponseBase<IPaymentClientSecretOutput>> => {
    return palipaliAPI.put(`api/payment_accounts/${payload.paymentAccountId}/stripe/setup_intent`, {}, new RestQueryParams(), {
        Authorization: `Bearer ${authToken}`,
    });
};
